import {establishOwnerFromDomain} from '../../../../_metronic/helpers/custom/funcs/establishOwnerFromDomain'
import {AuthModel} from './_models'
import {getConfig} from '../../../../_metronic/i18n/Metronici18n'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'

const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      // You can easily check auth_token expiration also
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {
      headers: {
        Owner: string
        Authorization: string
        'Accept-Language': string
      }
      url: string
    }) => {
      const {selectedLang} = getConfig()
      const auth = getAuth()
      const owner = establishOwnerFromDomain()

      config.headers['Accept-Language'] = selectedLang

      if (auth && auth.token) {
        config.headers.Authorization = `Bearer ${auth.token}`
      }
      config.headers.Owner = String(owner)

      return config
    },
    (err: any) => Promise.reject(err)
  )
  axios.interceptors.response.use(
    (response: any) => response,
    (err: any) => {
      const vector = process.env.REACT_APP_URL === 'crauzer.com'

      if (err.response && vector && err.response.status === 403) {
        removeAuth()
        window.location.href = '/logout'
      }
      return Promise.reject(err)
    }
  )
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY}
